import React, { useEffect, useMemo, useRef, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import { matchRoutes, useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
// import toast from "react-hot-toast";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { dashboard, downarrow, profileimg } from "../Assets/imgs";
import { adminIcon } from "../Assets/imgs";
import { roles } from "../Assets/imgs";
import { users } from "../Assets/imgs";
import { vehicle } from "../Assets/imgs";
import { transport } from "../Assets/imgs";
import { booking } from "../Assets/imgs";
import { transection } from "../Assets/imgs";
import { notify } from "../Assets/imgs";
import { FAQ } from "../Assets/imgs";
import { contactus } from "../Assets/imgs";
import { support, logoutIcon } from "../Assets/imgs";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import HttpClient from "../../Services/HttpClient";
import { useStore } from "../../zustand/useStore";
import toast from "react-hot-toast";
// import { logo } from "../Assets/imgs";
// import Postmanagement from "../../Screen/PostManagement/Postmanagement";

const SideBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/");
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [menuOpen, setMenuOpen] = useState(false);
  const [tripOpen, setTripOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [openMenu, setOpenMenu] = useState("");
  const menuRef = useRef(null);
  const { permissions, role } = useStore();

  // const adminData = JSON.parse(localStorage.getItem("admin_details"));
  const adminData = JSON.parse(localStorage.getItem("admin_details") || "{}");

  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [menuOpen]);

  const handleLogout = () => {
    setIsLoading(true);
    // Simulated logout logic; replace with API call as needed
    post(URLS.LOGOUT)
      .then((res) => {
        if (res?.status == "success") {
          toast.success("Logout Successfully");
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            setIsLoading(false);
            setPopup(false);
            HttpClient.defaults.headers.common["Authorization"] = "";
            window.location.reload();
            navigate("/");
          }, 1000);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const sidebarlist = useMemo(
    () => [
      {
        name: "Dashboard",
        icon: dashboard,
        route: "/general-user",
        permission: "CAN-VIEW-DASHBOARD",
      },
      {
        name: "Admin",
        icon: adminIcon,
        route: "/admin",
        matchRoutes: ["admin", "add-admin"],
        permission: "CAN-VIEW-ADMIN_LIST",
      },
      {
        name: "Roles",
        icon: roles,
        route: "/roles",
        matchRoutes: ["roles", "add-roles"],
        permission: "CAN-VIEW-ADMIN_ROLES",
      },
      {
        name: "User Management",
        icon: users,
        route: "/users",
        matchRoutes: ["users", "view-users"],
        permission: "CAN-VIEW-USERS",
      },
      {
        name: "Vehicle Master",
        icon: vehicle,
        route: "/vehicle",
        matchRoutes: ["vehicle", "add-vehicle"],
        permission: "CAN-VIEW-VEHICLES_MASTER",
      },
      {
        name: "Transport Management",
        icon: transport,
        route: "/transport",
        matchRoutes: [
          "view-transport",
          "add-transport",
          "vehicle-transport",
          "addvehicle-transport",
          "drivers-transport",
          "adddrivers-transport",
          "transport-bookings",
          "drivers-triphistory",
          "vehicle-triphistory",
        ],
        permission: "CAN-VIEW-TRANSPORT_MANAGEMENT",
      },
      {
        name: "Booking Management",
        icon: booking,
        route: "/booking-management",
        matchRoutes: ["booking-management", "booking-assign", "booking-request"],
        permission: "CAN-VIEW-BOOKING_MANAGEMENT",
      },
      {
        name: "Transactions",
        icon: transection,
        route: "/user-transactions",
        matchRoutes: ["transport-transaction", "transaction-view"],
        permission: "CAN-VIEW-TRANSACTION",
        children: [
          {
            name: "User Transactions",
            route: "/user-transactions",
          },
          {
            name: "Transport Transaction",
            route: "/transport-transaction",
          },
        ],
      },
      {
        name: "Push Notification",
        icon: notify,
        route: "/push-notification",
        matchRoutes:["push-notification","addpush-notification"],
        permission: "CAN-VIEW-PUSH_NOTIFICATIONS",
      },
      {
        name: "FAQ",
        icon: FAQ,
        route: "/faq",
        matchRoutes: ["faq", "faq-edit"],
        permission: "CAN-VIEW-HELP_&_SUPPORT",
      },
      {
        name: "Contact Us",
        icon: contactus,
        route: "/contact",
        matchRoutes: ["add-contact", "contact"],
        permission: "CAN-VIEW-CONTACT_US",
      },
      {
        name: "Help & Support",
        icon: support,
        route: "/help-support",
        matchRoutes:["help-support","help-view"],
        permission: "CAN-VIEW-HELP_&_SUPPORT",
      },
    ],
    []
  );
  const permittedSidebarList = useMemo(() => {
    const normalizedPermissions = Array.isArray(permissions) ? permissions : [];
    return sidebarlist.filter((item) => {
      if (!item.permission) {
        return true;
      }
      return normalizedPermissions.includes(item.permission);
    });
  }, [permissions, sidebarlist]);

  useEffect(() => {
    permittedSidebarList.forEach((item) => {
      if (item.children?.some((child) => pathname.includes(child.route))) {
        setOpenMenu(item.name);
      }
    });
  }, [pathname, permittedSidebarList]);

  // const isMenuActive = (item) => {
  //   // check submenu
  //   if (item.children) {
  //     return item.children.some((child) =>
  //       splitLocation.includes(child.route.replace("/", "")),
  //     );
  //   }

  //   // check multiple routes
  //   if (item.matchRoutes) {
  //     return item.matchRoutes.includes(splitLocation[1]);
  //   }

  //   // default route match
  //   return splitLocation.includes(item.route.replace("/", ""));
  // };

  const isMenuActive = (item) => {
    const currentPath = pathname;
    const pathSegments = currentPath.split("/");

    // ✅ Transactions special case
    if (item.name === "Transactions") {
      if (
        currentPath.startsWith("/user-transactions") ||
        currentPath.startsWith("/transport-transaction") ||
        currentPath.startsWith("/transaction-view")
      ) {
        return true;
      }
    }

    // ✅ children
    if (item.children) {
      if (
        item.children.some((child) =>
          currentPath.startsWith(child.route)
        )
      ) {
        return true;
      }
    }

    // ✅ matchRoutes (STRICT FIX HERE)
    if (item.matchRoutes) {
      if (
        item.matchRoutes.some((route) =>
          pathSegments.includes(route)
        )
      ) {
        return true;
      }
    }

    // ✅ default
    // return currentPath.startsWith(item.route);
    return (
      currentPath === item.route ||
      currentPath.startsWith(item.route + "/")
    );
  };

  return (
    <div className={`${saideBarShow ? " sidebar" : "close_sidebar"} `}>
      <header>
        <div className="image_text pointer d-flex ac-jc">
          <div
            style={{
              backgroundColor: "#259AF91A",
              borderRadius: 8,
              width: "90%",
              justifyContent: "space-between",
            }}
            className="d-flex ac-js text-black p-2 mt-2"
          >
            {saideBarShow ? (
              <div className="d-flex ac-jc">
                <img src={profileimg} className="logo-profile" alt="logo" />
                <div className="d-flex ms-2 flex-column">
                  <label className="text-black fw-bold">
                    {adminData?.name}
                  </label>
                  <span style={{ fontSize: 12 }}>{adminData?.role}</span>
                </div>
              </div>
            ) : (
              <div className="d-flex ac-jc">
                <img src={profileimg} className="logo-profile" alt="logo" />
              </div>
            )}
            <img src={downarrow} className="arrowSize" alt="logo" />
          </div>
        </div>
      </header>

      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links d-flex flex-column  align-items-start ps-0">
            {permittedSidebarList.map((item, index) => (
              <li
                className="nav_link trans  flex-column"
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div
                  className="d-flex w-100"
                  onClick={() => {
                    console.log("Clicked:", item.name);
                    if (item.children) {
                      setOpenMenu(openMenu === item.name ? "" : item.name);
                      // setOpenMenu(item.name);
                      navigate(item.children[0].route);
                    } else {
                      setOpenMenu("");
                      navigate(item.route);
                    }
                  }}
                >
                  <h4
                    className={`ps - 3 ${isMenuActive(item) ? "f3 active_bar" : ""} `}
                  >
                    <img
                      src={item.icon}
                      className="icon"
                      style={{
                        filter:
                          hoveredIndex === index
                            ? "brightness(0) saturate(100%) invert(63%) sepia(77%) saturate(749%) hue-rotate(340deg) brightness(99%) contrast(96%)"
                            : "grayscale(100%) brightness(0.5)",
                      }}
                    />
                    <div className="d-flex ac-jb w-100">
                      <span className="text text-nowrap f2 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                        {item.name}
                      </span>
                      <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex justify-content-end mx-3 w-100">
                        {item.name === "Transactions" &&
                          (openMenu === "Transactions" ? (
                            <KeyboardArrowUpOutlinedIcon />
                          ) : (
                            <KeyboardArrowDownOutlinedIcon />
                          ))}
                      </span>
                    </div>
                  </h4>
                </div>

                {/* Submenu */}
                {/* {item.name === "Transactions" &&
                  openMenu === "Transactions" &&
                  item.children?.map((child, i) => (
                    <div
                      key={i}
                       className={` ps-5 py-2 f2  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ms-1 w-90 pointer ${pathname.includes(child.route) ? "active_bar" : ""} `}
                     
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(child.route);
                      }}
                    >
                      {child.name}
                    </div>
                  ))} */}

                {item.name === "Transactions" &&
                  openMenu === "Transactions" &&
                  item.children?.map((child, i) => (
                    <div
                      key={i}
                      className={`ps-5 py-2 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ms-1 w-90 pointer ${(child.route === "/transport-transaction" &&
                        (pathname.includes("/transport-transaction") ||
                          pathname.includes("/transaction-view"))) ||
                        pathname.includes(child.route)
                        ? "active_bar"
                        : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(child.route);
                      }}
                    >
                      {child.name}
                    </div>
                  ))}

              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* Logout Button */}
      <div
        className="d-flex ac-js py-3 px-2 log_bot"
        onClick={() => setPopup(true)}
      >
        <img
          src={logoutIcon}
          width={17}
          height={17}
          className="cursor-pointer"
        />
        <h4
          style={{ color: "#DE3C1E" }}
          className="f2 fs-md-16 fs-xl-16 mb-0  ms-2 pointer"
        >
          Logout
        </h4>
        {/* {menuOpen ? (
          <KeyboardArrowUpIcon
            className="arrow-down "
            onClick={handleCloseMenu}
          />
        ) : (
          <KeyboardArrowDownIcon
            className="arrow-down "
            onClick={() => setMenuOpen(true)}
          />
        )} */}
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 mt-4 text-center" style={{ color: "#DE3C1E" }}>
              Log out
            </h2>
            <p className="f3 mt-4 text-center" style={{ color: "#0e0d0d" }}>
              Are you sure, want to Logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => setPopup(false)}
                className="delete-btn-cancel w-40"
              >
                Close
              </button>
              <button
                onClick={handleLogout}
                className="delete-btn-confirm  f2 w-40"
              >
                {/* Confirm */}
                              {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "white", padding: 8 }}
                ></span>
              </>
            ) : (
              "Confirm"
            )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SideBar;
